module.exports = __webpack_public_path__ + "img/background017.6116384d.jpg";